/* oxlint-disable */
/* oxfmt-ignore */
// Generated by IconWatcher. ‼️ DO NOT MODIFY THIS FILE ‼️
// It's recommended to commit this file.
import { z } from 'zod'
import { fa1, fa2, fa3, faAppleWhole, faArrowLeft, faArrowRight, faArrowRightLong, faArrowUpRightFromSquare, faArrowsRotate, faBacon, faBan, faBiking, faBowlFood, faBug, faBuilding, faBullhorn, faCalendar, faCalendarDays, faCarrot, faCheck, faCheckCircle, faCheese, faChevronDown, faChevronRight, faChevronUp, faCircleHalfStroke, faCircleInfo, faCity, faClock, faCloudUploadAlt, faComment, faCommentDots, faCommentSlash, faComments, faCompass, faCopy, faDownload, faEdit, faEnvelope, faEuro, faEuroSign, faExclamationTriangle, faEye, faEyeSlash, faFile, faFileCircleQuestion, faFileDownload, faFireBurner, faFish, faFlag, faGlassWater, faHamburger, faHandHoldingHeart, faHandHoldingMedical, faHandsHelping, faHandshake, faHandshakeAngle, faHome, faHouse, faHouseChimney, faInfoCircle, faKitchenSet, faLeaf, faLink, faLocationDot, faMailBulk, faMinus, faMoneyBill, faMoon, faPenRuler, faPenToSquare, faPeopleArrows, faPeopleLine, faPhone, faPhotoVideo, faPlay, faPlus, faQuestion, faSave, faSeedling, faShare, faShuffle, faStop, faSun, faThumbsDown, faThumbsUp, faUmbrellaBeach, faUpRightFromSquare, faUser, faUserGroup, faUserPen, faUsers, faUtensils, faWheatAwn, faX, faXmark, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faFacebookF, faInstagram, faLinkedin, faLinkedinIn, faPinterestP, faWhatsapp, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons'

export const faIconValidation = z.enum([
  'fa-1',
  'fa-2',
  'fa-3',
  'fa-apple-whole',
  'fa-arrow-left',
  'fa-arrow-right',
  'fa-arrow-right-long',
  'fa-arrow-up-right-from-square',
  'fa-arrows-rotate',
  'fa-bacon',
  'fa-ban',
  'fa-biking',
  'fa-bowl-food',
  'fa-bug',
  'fa-building',
  'fa-bullhorn',
  'fa-calendar',
  'fa-calendar-days',
  'fa-carrot',
  'fa-check',
  'fa-check-circle',
  'fa-cheese',
  'fa-chevron-down',
  'fa-chevron-right',
  'fa-chevron-up',
  'fa-circle-half-stroke',
  'fa-circle-info',
  'fa-city',
  'fa-clock',
  'fa-cloud-upload-alt',
  'fa-comment',
  'fa-comment-dots',
  'fa-comment-slash',
  'fa-comments',
  'fa-compass',
  'fa-copy',
  'fa-download',
  'fa-edit',
  'fa-envelope',
  'fa-euro',
  'fa-euro-sign',
  'fa-exclamation-triangle',
  'fa-eye',
  'fa-eye-slash',
  'fa-facebook',
  'fa-facebook-f',
  'fa-file',
  'fa-file-circle-question',
  'fa-file-download',
  'fa-fire-burner',
  'fa-fish',
  'fa-flag',
  'fa-glass-water',
  'fa-hamburger',
  'fa-hand-holding-heart',
  'fa-hand-holding-medical',
  'fa-hands-helping',
  'fa-handshake',
  'fa-handshake-angle',
  'fa-home',
  'fa-house',
  'fa-house-chimney',
  'fa-info-circle',
  'fa-instagram',
  'fa-kitchen-set',
  'fa-leaf',
  'fa-link',
  'fa-linkedin',
  'fa-linkedin-in',
  'fa-location-dot',
  'fa-mail-bulk',
  'fa-minus',
  'fa-money-bill',
  'fa-moon',
  'fa-pen-ruler',
  'fa-pen-to-square',
  'fa-people-arrows',
  'fa-people-line',
  'fa-phone',
  'fa-photo-video',
  'fa-pinterest-p',
  'fa-play',
  'fa-plus',
  'fa-question',
  'fa-save',
  'fa-seedling',
  'fa-share',
  'fa-shuffle',
  'fa-spinner fa-pulse',
  'fa-stop',
  'fa-sun',
  'fa-thumbs-down',
  'fa-thumbs-up',
  'fa-umbrella-beach',
  'fa-up-right-from-square',
  'fa-user',
  'fa-user-group',
  'fa-user-pen',
  'fa-users',
  'fa-utensils',
  'fa-whatsapp',
  'fa-wheat-awn',
  'fa-x',
  'fa-x-twitter',
  'fa-xmark',
  'fa-youtube',
  'fi-gb',
  'fi-nl'
])

export type FAIconName = z.infer<typeof faIconValidation>

export const faIcons = [fa1, fa2, fa3, faAppleWhole, faArrowLeft, faArrowRight, faArrowRightLong, faArrowUpRightFromSquare, faArrowsRotate, faBacon, faBan, faBiking, faBowlFood, faBug, faBuilding, faBullhorn, faCalendar, faCalendarDays, faCarrot, faCheck, faCheckCircle, faCheese, faChevronDown, faChevronRight, faChevronUp, faCircleHalfStroke, faCircleInfo, faCity, faClock, faCloudUploadAlt, faComment, faCommentDots, faCommentSlash, faComments, faCompass, faCopy, faDownload, faEdit, faEnvelope, faEuro, faEuroSign, faExclamationTriangle, faEye, faEyeSlash, faFile, faFileCircleQuestion, faFileDownload, faFireBurner, faFish, faFlag, faGlassWater, faHamburger, faHandHoldingHeart, faHandHoldingMedical, faHandsHelping, faHandshake, faHandshakeAngle, faHome, faHouse, faHouseChimney, faInfoCircle, faKitchenSet, faLeaf, faLink, faLocationDot, faMailBulk, faMinus, faMoneyBill, faMoon, faPenRuler, faPenToSquare, faPeopleArrows, faPeopleLine, faPhone, faPhotoVideo, faPlay, faPlus, faQuestion, faSave, faSeedling, faShare, faShuffle, faStop, faSun, faThumbsDown, faThumbsUp, faUmbrellaBeach, faUpRightFromSquare, faUser, faUserGroup, faUserPen, faUsers, faUtensils, faWheatAwn, faX, faXmark, faSpinner, faFacebook, faFacebookF, faInstagram, faLinkedin, faLinkedinIn, faPinterestP, faWhatsapp, faXTwitter, faYoutube]
